import {DataChannel, DataChannelListener} from "./DataChannel";

export class NullDataChannel implements DataChannel {
    addEventSourceListener(_sseName: string, _listener: DataChannelListener): void {
        // do nothing
    }

    removeEventSourceListener(_sseName: string, _listener: DataChannelListener): void {
        // do nothing
    }
}
